import { X } from 'lucide-react';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL } from '../../config/auth0';
import { startAuth0PKCE } from '../../utils/auth0pkce';

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  planName: string;
  planId: string;
  customerType: string;
}

export function LoginPromptModal({ isOpen, onClose, planName, planId, customerType }: LoginPromptModalProps) {
  if (!isOpen) return null;
  
  const handleLogin = () => {
    // Stocker temporairement le plan sélectionné dans localStorage pour le récupérer après connexion
    localStorage.setItem('selected_plan', JSON.stringify({
      id: planId,
      name: planName,
      customerType: customerType
    }));
    
    // Stocker l'information que l'utilisateur doit être redirigé vers la page d'abonnement après connexion
    sessionStorage.setItem('auth0_redirect_after_login', '/abonnement');
    
    // Rediriger vers Auth0 pour la connexion avec PKCE
    startAuth0PKCE('login', AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL);
    onClose();
  };
  
  const handleSignup = () => {
    // Stocker temporairement le plan sélectionné dans localStorage pour le récupérer après inscription
    localStorage.setItem('selected_plan', JSON.stringify({
      id: planId,
      name: planName,
      customerType: customerType
    }));
    
    // Stocker l'information que l'utilisateur doit être redirigé vers la page d'abonnement après inscription
    sessionStorage.setItem('auth0_redirect_after_login', '/abonnement');
    
    // Rediriger vers Auth0 pour l'inscription avec PKCE
    startAuth0PKCE('signup', AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL);
    onClose();
  };
  
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="h-6 w-6" />
        </button>
        
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          Connectez-vous pour continuer
        </h3>
        
        <div className="text-gray-600 mb-6">
          <p className="mb-2">Pour souscrire au plan <span className="font-semibold">{planName}</span>, vous devez avoir un compte Wanzo.</p>
          <p>Connectez-vous si vous avez déjà un compte, ou créez un compte pour commencer.</p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={handleLogin}
            className="w-full rounded-full bg-primary hover:bg-primary-hover text-white py-2.5 font-medium transition-colors"
          >
            Se connecter
          </button>
          
          <button
            onClick={handleSignup}
            className="w-full rounded-full border-2 border-primary text-primary hover:bg-primary hover:text-white py-2.5 font-medium transition-colors"
          >
            Créer un compte
          </button>
          
          <button
            onClick={onClose}
            className="w-full text-gray-500 hover:text-gray-700 py-2 text-sm transition-colors"
          >
            Continuer sans compte
          </button>
        </div>
      </div>
    </div>
  );
}
